var siteConfig = {
  // 使用window.location.hostname获取key
  'lx.zhqy.sclf.top': {
    siteName: '利辛县'
  },
  'cd.zhqy.sclf.top': {
    siteName: '四川省'
  },
  'xg.zhqy.sclf.top': {
    siteName: '兴国县'
  }
}

const getSiteName = function () {
  let config = siteConfig[window.location.hostname];
  return (config && config.siteName) || ''
}

export {getSiteName}
